<template>
	<div>
		<BusinessBanner />
		<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
			<InventoryNavi />
			<div class="widget-location">
				<h3>상품등록현황</h3>
			</div>
			
			<div class="search-card">
				<div class="search-form-inline">
					<div class="form-item-group">
						<span class="form-item-label">상품코드</span>
						<el-input v-model="code" placeholder="상품코드" class="form-item-input" clearable></el-input>
					</div>
					<div class="form-item-group">
						<span class="form-item-label">바코드</span>
						<el-input v-model="barcode" placeholder="바코드" class="form-item-input" clearable></el-input>
					</div>
					<div class="form-item-group">
						<span class="form-item-label">상품명</span>
						<el-input v-model="goods_name" placeholder="상품명" class="form-item-input" clearable></el-input>
					</div>
					<div class="form-action-group">
						<el-button type="primary" icon="el-icon-search" @click="changeSearch">검색</el-button>
						<el-button icon="el-icon-refresh" @click="onReset">검색 초기화</el-button>
					</div>
				</div>
			</div>
			
			
			<div class="table-list" v-if="!isMobile">
				<div class="page-info">
					<span>전체 : <strong>{{total}}</strong> ({{current_page}}/{{last_page}} 페이지)</span>
				</div>
				
				<el-table
				    :data="tableData"
				    stripe empty-text="데이타가 없습니다."
				    style="width: 100%">
				<!--    <el-table-column
				      prop="date"
				      label="이미지"
				      width="180">
				    </el-table-column> -->
				    <el-table-column
				      label="상품정보">
						<template slot-scope="scope">
							<div><a class="scope-a" :href="scope.row.url" target="_blank">{{ scope.row.goods_name }}</a></div>
						</template>
				    </el-table-column>
					<el-table-column label="상품 상세 정보" min-width="320">
					  <template slot-scope="scope">
						<div class="agency-info-row">
						  <!-- 1. 상품코드 -->
						  <div class="info-badge">
							<span class="badge-label">상품코드</span>
							<span class="badge-value">{{ scope.row.code || '-' }}</span>
						  </div>
						  <!-- 2. 배송센터 -->
						  <div class="info-badge">
							<span class="badge-label">배송센터</span>
							<span class="badge-value">해상</span>
						  </div>
						  <!-- 3. 단가 (CNY) -->
						  <div class="info-badge" v-if="scope.row.price">
							<span class="badge-label">단가</span>
							<span class="badge-value" style="color: #ff5700; font-weight: bold;">{{ scope.row.price }} CNY</span>
						  </div>
						  <!-- 4. 색상 -->
						  <div class="info-badge" v-if="scope.row.color">
							<span class="badge-label">색상</span>
							<span class="badge-value">{{ scope.row.color }}</span>
						  </div>
						  <!-- 5. 사이즈 -->
						  <div class="info-badge" v-if="scope.row.size">
							<span class="badge-label">사이즈</span>
							<span class="badge-value">{{ scope.row.size }}</span>
						  </div>
						  <!-- 6. 바코드 -->
						  <div class="info-badge" v-if="scope.row.barcode">
							<span class="badge-label">바코드</span>
							<span class="badge-value">{{ scope.row.barcode }}</span>
						  </div>
						  <!-- 7. 입고현황 -->
						  <div class="info-badge">
							<span class="badge-label">입고현황</span>
							<span class="badge-value">
							  <span class="color-blue" style="font-weight: bold;">{{ scope.row.warehouse_apply }}</span>
							  <span> / </span>
							  <span>{{ scope.row.warehouse_num }}</span>
							</span>
						  </div>
						  <!-- 8. 발송신청 -->
						  <div class="info-badge">
							<span class="badge-label">발송신청</span>
							<span class="badge-value">{{ scope.row.shipping_apply }}</span>
						  </div>
						  <!-- 9. 잔여수량 -->
						  <div class="info-badge">
							<span class="badge-label">잔여수량</span>
							<span class="badge-value" style="color: #67c23a; font-weight: bold;">{{ scope.row.remaining_quantity }}</span>
						  </div>
						</div>
					  </template>
					</el-table-column>
					 <el-table-column label="메뉴" width="240">
					      <template slot-scope="scope">
							<div style="display: flex; flex-wrap: wrap; gap: 6px; align-items: center;">
								<el-button
								  size="mini"  type="primary" plain v-if="scope.row.warehouse_apply==0"
								  @click="handleEdit(scope.$index, scope.row)">수정하기</el-button>
								<el-button
								  size="mini"
								  type="danger" plain
								  @click="handleDelete(scope.$index, scope.row)">삭제</el-button>
							</div>
					      </template>
					</el-table-column>
				  </el-table>
				  
				    <div class="block">
				      <el-pagination
				        layout="prev, pager, next"  :page-size="20"
				        :total="total"  @current-change="handleCurrentChange" >
				      </el-pagination>
				    </div>
			</div>
			
			<div v-else class="table-list">
				<div class="page-info">
					<span>전체 : <strong>{{total}}</strong> ({{current_page}}/{{last_page}} 페이지)</span>
				</div>
				<div class="info-wrap" v-for="(item,index) in tableData" :key="index" >
					<div class="item-info-wrap">
						<div class="info-right-top">
							<span class="item-center">[해상]</span>
							<span class="item-code">상품코드 : {{item.code}}</span>
						</div>
						<div class="info-right-bottom">
							<div class="item-goodsname">
								<a :href="item.url" target="_blank">{{item.goods_name}}</a>
							</div>
						</div>
					</div>
					<div class="item-option-wrap">
						단가: <span class="item-option item-option-price">{{item.price}} CNY</span>, 색상: <span class="item-option item-option-color">{{item.color}}</span>, 사이즈: <span class="item-option item-option-size">{{item.size}}</span>, 바코드: <span class="item-option item-option-barcode">{{item.barcode}}</span>
					</div>
					
					<div class="item-quantity-wrap">
						<div class="item-quantity">
							<div>입고신청 : <span class="color-blue">{{item.warehouse_apply}}</span></div>
							<div>입고 : {{item.warehouse_num}}</div>
							<div>발송신청 : {{item.shipping_apply}}</div>
							<div>잔여 : {{item.remaining_quantity}}</div>
						</div>
					</div>
					
					<div style="display: flex;justify-content: space-between;">
						<el-button
						  size="mini"  type="primary" plain v-if="item.warehouse_apply==0"
						  @click="handleEdit(index, item)">수정하기</el-button>
						<el-button
						  size="mini"
						  type="danger" plain
						  @click="handleDelete(index, item)">삭제</el-button>
					</div>
					
					
				</div>
				
				
			</div>
			
			
			<el-dialog title="수정하기" :visible.sync="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" :width="isMobile?'96%':'800px'">
				<el-form :model="form"  ref="ruleForm" >
					<div class="form-item" >
						<el-row>
							<el-col :xs="24" :sm="12" class="item">
								<div class="from-title">품목분류 <span class="required-addon">(*)</span>
									<el-popover
									   placement="top-start"
									   width="300"
									   trigger="hover"
									   >
										<div>
									   	원하시는 품목분류가 없으신가요?<br>추가희망 하시는 품목분류를 고객센터로<br>알려주시면 즉시 추가하여드립니다
										</div>
										<i style="margin-left: 10px;" class="el-icon-question icon-question" slot="reference"></i>
									 </el-popover>
								</div>
								<el-form-item  prop="category_name"
								:rules="[
									{ required: true, message: '품목분류 필수', trigger: 'change' },
								]">
									<el-popover
										placement="bottom"
										width="700"
										trigger="click"
										v-model="form.showPopover"
										@show="onCategoryDialog"
										popper-class="category-popper"
										style="flex: 1;"
									>
										<div class="category-dropdown-content">
											<div class="scroller-container">
												<div class="v-table-header">
													<div class="v-col-l1">1차 분류</div>
													<div class="v-col-l2">2차 분류 (HS Code)</div>
													<div class="v-col-l3">3차 분류 (상세)</div>
												</div>
												
												<RecycleScroller
													class="category-v-scroller"
													:items="form.showPopover ? filteredCategories : []"
													:item-size="65"
													key-field="uniqueId"
													v-slot="{ item: catItem }"
												>
													<div class="v-category-row" @click="handleSelectCategory(catItem)" style="cursor: pointer;">
														<div class="v-col-l1">
															<div class="ko" v-html="highlightCategoryText(catItem.l1)"></div>
														</div>
														<div class="v-col-l2">
															<div class="ko">
																<span v-html="highlightCategoryText(catItem.l2)"></span>
																<span class="code">({{' '}}<span v-html="highlightCategoryText(catItem.l2_code)"></span>{{' '}})</span>
															</div>
															<div class="cn" v-if="catItem.l2_cn" v-html="highlightCategoryText(catItem.l2_cn)"></div>
														</div>
														<div class="v-col-l3">
															<div class="ko" v-html="highlightCategoryText(catItem.l3)"></div>
															<div class="code" v-if="catItem.l3_code !== '-'" v-html="highlightCategoryText(catItem.l3_code)"></div>
														</div>
													</div>
												</RecycleScroller>
											</div>
										</div>
										<el-input 
											slot="reference" 
											v-model="form.category_name" 
											placeholder="분류를 입력하거나 선택하세요" 
											@input="onSearchInput"
											class="input-frame"
										></el-input>
									</el-popover>
									<el-popover
									   placement="top-start"
									   width="300"
									   trigger="hover"
									   >
										<div>
									   	원하시는 품목분류가 없으신가요?<br>추가희망 하시는 품목분류를 고객센터로<br>알려주시면 즉시 추가하여드립니다
										</div>
										<i style="margin-left: 10px;" class="el-icon-question icon-question" slot="reference"></i>
									 </el-popover>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12"  class="item">
								<div class="from-title">상품명(영문) <span class="required-addon">(*)</span>
									<el-popover
									   placement="top-start"
									   width="300"
									   trigger="hover"
									   >
									   <div>검색( HS코드네비게이션)에서 보다 정확한 결과를 얻을수 있습니다</div>
											<i class="el-icon-question icon-question" slot="reference"></i>
									 </el-popover>
								</div>
								<el-form-item  prop="goods_name"
								:rules="[
									{ required: true, message: '상품명 필수', trigger: 'blur' },
								]">
									<el-input v-model="form.goods_name" class="input-frame" ></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12"  class="item">
								<div class="from-title">적하품명(영문) </div><!--卸载货物(英文) 描述概况-->
								<el-form-item  prop="descript">
									<el-input v-model="form.descript" class="input-frame" ></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12"  class="item">
								<div class="from-title">상품코드 
									<el-popover
									   placement="top-start"
									   width="300"
									   trigger="hover"
									   >
									    <div>국내마켓 상품관리에 필요한 상품코드를 입력 관리해보세요</div>
										<i class="el-icon-question icon-question" slot="reference"></i>
									 </el-popover>
								</div><!--商品代码-->
								<el-form-item  prop="code">
									<el-input v-model="form.code" readonly class="input-frame" ></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12"  class="item">
								<div class="from-title">단가 <span class="required-addon">(*)</span>CNY</div><!--单价-->
								<el-form-item  prop="price"
								:rules="[
									{ required: true, message: '단가 필수', trigger: 'blur' },
								]">
									<el-input v-model="form.price" type="number" class="input-frame"  ></el-input>
									
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12"  class="item">
								<div class="from-title">브랜드/셀러 </div><!-- 销售方-->
								<el-form-item  prop="seller" >
									<el-input v-model="form.seller" class="input-frame" ></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12"  class="item">
								<div class="from-title">바코드 </div><!-- 条形码 -->
								<el-form-item  prop="barcode">
									<el-input v-model="form.barcode" class="input-frame" ></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12"  class="item">
								<div class="from-title">색상(중국어) </div><!-- 颜色（中文） -->
								<el-form-item prop="color">
									<el-input v-model="form.color" class="input-frame" ></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12"  class="item">
								<div class="from-title">사이즈(중국어) </div><!-- 尺寸（中文） -->
								<el-form-item  prop="size">
									<el-input v-model="form.size" class="input-frame" ></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12"  class="item">
								<div class="from-title">HS CODE </div>
								<el-form-item  prop="hs_code">
									<el-input v-model="form.hs_code" class="input-frame" ></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="24"  class="item">
								<div class="from-title">상품 URL <span class="required-addon">(*)</span></div>
								<el-form-item prop="url"
								:rules="[
										{ required: true, message: '상품 URL 필수', trigger: 'blur' },
										{ type: 'url', message: '올바른 URL 형식이 아닙니다', trigger: 'blur' }
								]">
									<el-input v-model="form.url" :class="isMobile?'input-frame':'input-frame-1270'" ></el-input>
								</el-form-item>
							</el-col>
								
						</el-row>
					</div>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogFormVisible = false">취소</el-button>
					<el-button type="primary" @click="submitForm('ruleForm')">수정하기</el-button>
				</div>
			</el-dialog>
			

			
		</div>
		
	</div>
</template>

<script>
	import BusinessBanner from '../../components/BusinessBanner.vue'
	import InventoryNavi from '../../components/InventoryNavi.vue'
	import request from '@/utils/request'
	import categoryData from '@/assets/fenlei_final_with_10_names_no_cat4.min.json'
	export default {
		components: {
			BusinessBanner,
			InventoryNavi
		},
		data() {
			return{
				code:"",
				barcode:"",
				goods_name:"",
				total:0,
				current_page:1,
				last_page:1,
				page:1,
				tableData: [],
				
				dialogFormVisible: false,
				form: {
					id:'',
				  category_id:'',
				  category_name:'',
				  goods_name: '',
				  descript:'',
				  code:'',
				  price:'',
				  seller:'',
				  barcode:'',
				  color:'',
				  size:'',
				  hs_code:'',
				  url:'',
				  showPopover: false,
				},
				formLabelWidth: '120px',
				CategoryVisible: false,
				category_list:[],
				search: '',
				flattenedCategories: [],
				categorySearch: '',
				loading: true,
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			},
			filteredCategories() {
				if (!this.categorySearch) {
					return this.flattenedCategories
				}
				const query = this.categorySearch.toLowerCase()
				return this.flattenedCategories.filter(item => {
					return (
						(item.l1 && item.l1.toLowerCase().includes(query)) ||
						(item.l2 && item.l2.toLowerCase().includes(query)) ||
						(item.l2_code && item.l2_code.toLowerCase().includes(query)) ||
						(item.l2_cn && item.l2_cn.toLowerCase().includes(query)) ||
						(item.l2_en && item.l2_en.toLowerCase().includes(query)) ||
						(item.l3 && item.l3.toLowerCase().includes(query)) ||
						(item.l3_code && item.l3_code.toLowerCase().includes(query))
					)
				})
			},
		},	
		created(){
			this.getList()
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						console.log(this.form,222221111)
						request.post('/member/Inventory/editGoods',
							this.form
						).then(response => {
							console.log(response,"")			  
							if(response.code ==1){
								alert('상품 수정 성공！');
								this.dialogFormVisible = false
								this.getList()// 成功后刷新列表数据
								console.log('提交成功！');
								// this.$router.replace('/inventoryItem');
							}else{
								alert(response.msg?response.msg:"실패")
								return
							}
														
						});
						
					}
					
					
				})
			},
			handleEdit(index, row) {
				console.log(index, row);
				this.form = { ...row, showPopover: false }
				this.dialogFormVisible = true
				
			},
			handleDelete(index, row) {
				console.log(index, row);
				console.log(row.id)
				
				this.$confirm('정말 삭제하겠습니까?', '', {
				  confirmButtonText: '확인',
				  cancelButtonText: '취소',
				  type: 'warning'
				}).then(() => {
					request.post('/member/Inventory/deleteGoods',{
						id:row.id
					})
					.then(res => {
						console.log(res,"")
						if(res.code ==1){
							this.$message({
								type: 'success',
								message: '삭제 성공!'
							});
							this.page = 1
							this.getList()
						}		
					});
					
				}).catch(() => {     
				});
				      
			},
			getList(){
				this.loading = true
				console.log("获取列表")
				request.post('/member/Inventory/getGoodsList',{
					page:this.page,
					code:this.code,
					barcode:this.barcode,
					goods_name:this.goods_name,
				})
				.then(res => {
					this.loading = false
					console.log(res,"212")
					if(res.code ==1){
						this.total = res.data.total
						this.current_page = res.data.current_page
						this.last_page = res.data.last_page
						this.tableData= res.data.data
					}
						
				}).catch(() => {
					this.loading = false
				});
				
			},
			handleCurrentChange(val) {
			    console.log(`当前页: ${val}`);
				this.page = val
				this.getList()
			},
			changeSearch(){
				this.page = 1
				this.getList()	
			},
			onReset(){
				this.code=""
				this.barcode=""
				this.goods_name=""
				this.page = 1
				this.getList()
			},
			onSearch(){
				console.log(this.search)
				this.getCategoryList()
			},
			getCategoryList(){
				request.post('/member/Agency/getCategoryList',{
					search:this.search
				})
				.then(res => {
					if(res.code ==1){
						this.category_list = res.data
					}	
				});
			},
	
			onCategoryDialog(){
				if (this.flattenedCategories.length === 0) {
					this.processCategories()
				}
			},
			processCategories() {
				const result = []
				let counter = 0
				categoryData.categories.forEach((cat) => {
					cat.items.forEach((item) => {
						if (item.hscode_10_details && item.hscode_10_details.length > 0) {
							item.hscode_10_details.forEach((h10) => {
								result.push({
									uniqueId: counter++,
									item_id: item.id,
									l1: cat.category_name,
									l2: item.name_ko,
									l2_code: item.hs_code,
									l2_cn: item.name_cn,
									l2_en: item.name_en,
									l3: h10.hscode_10_name,
									l3_code: h10.hscode_10
								})
							})
						} else {
							result.push({
								uniqueId: counter++,
								item_id: item.id,
								l1: cat.category_name,
								l2: item.name_ko,
								l2_code: item.hs_code,
								l2_cn: item.name_cn,
								l2_en: item.name_en,
								l3: '-',
								l3_code: '-'
							})
						}
					})
				})
				this.flattenedCategories = Object.freeze(result)
			},
			highlightCategoryText(text) {
				if (!this.categorySearch || text === undefined || text === null || text === '-') return text
				const str = String(text)
				const query = this.categorySearch.trim().toLowerCase()
				if (!query) return str
				const regex = new RegExp(query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi')
				return str.replace(regex, match => `<span class="hl-text-category">${match}</span>`)
			},
			handleSelectCategory(row) {
				console.log("选择分类:", row)
				this.form.category_name = row.l2;
				this.form.goods_name = row.l2_en;
				this.form.hs_code = (row.l3_code && row.l3_code !== '-') ? row.l3_code : row.l2_code;
				this.form.category_id = row.item_id;
				this.form.showPopover = false;
			},
			onSearchInput() {
				this.categorySearch = this.form.category_name
				this.form.showPopover = true
			},
			onCategoryName(id,name){
				// 暂时由 handleSelectCategory 处理
			},
			
			
		}
		
	}
</script>

<style scoped>
	.widget-location {
	    margin-top: 50px;
	    margin-bottom: 60px;
	    text-align: center;
	}
	.widget-location h3 {
	    padding: 0;
	    margin: 0;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	}
	.condition-wrap{
		padding: 0 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		/* margin: 0 auto;
		padding: 0 auto; */
	}
	.condition-wrap .unit{
		font-weight: bold;
		width:100px;
		/* margin: 0 10px 0 20px; */
	}
	.unit-input{
		width:200px;
	}
	.table-list{
		margin:30px 0;
	}
	.table-list .page-info{
		font-size: 16px;
		font-weight: bold;
		padding:0 30px 20px;
	}
	.table-list .page-info strong{
		font-weight: normal;
		color: var(--main-color);
	}
	.table-list .block{
		padding-top: 20px;
		text-align: center;
	}
	/* 弹框表单 */
	.form-item .item{
		display: flex;
		align-items: center; 
		/* padding-bottom: 20px; */
	}
	.from-title{
		width: 125px;
		padding-bottom: 20px;
	}
	.input-frame{
		width: 200px;
		margin: 0 10px;
	}
	.input-frame-1270{
		width: 580px;
		margin: 0 10px;
	}
	.required-addon{
		font-family: inherit;
		color: var(--main-color);
		font-weight: inherit;
		vertical-align: inherit;
	}
	.icon-question{
		color:var(--main-color);padding-left: 5px;font-size: 18px;
	}
	/* 分类弹框 */
	.agency-category-customs{
		display: flex;
	}
	.agency-category-customs .type-general{
		background-color: #0055d4;
		width: 18px;
		height: 18px;
		border-radius: 6px;
		margin: 0 5px 0 15px;
	}
	.agency-category-customs .type-list{
		background-color: #c33;
		width: 18px;
		height: 18px;
		border-radius: 6px;
		margin: 0 5px 0 15px;
	}
	.help-block{
	    background-color: #d5e6fa;
	    color: #274780;
	    display: flex;
	    min-height: 40px;
		padding:5px 0;
	    border-radius: 12px;
	    align-items: center;
	    padding-left: 19px;
	    margin: 17px 0 20px;
	}
	.agreement-box{
		border: 1px solid var(--border-color);
	/* 	background: #F5F8FD; */
		padding: 15px;
		margin: 25px 0 5px;
		border-radius: 20px;
	}
	.height-fixed-box{
		/* background: #F5F8FD; */
		height: 400px;
		overflow-y: scroll;
		padding-right: 20px;
		font-size: 12px;
		color: #333;
	}
	.height-fixed-box ol {
	    margin: 0;
	    padding: 0;
	}
	.height-fixed-box .depth1 {
	    border: 1px solid #e5e5e5;
	    border-radius: 13px;
	    margin-bottom: 20px;
	}
	.height-fixed-box li {
	    margin: 0 0 30px 0;
	    padding: 0;
	    list-style: none;
	}
	.height-fixed-box li li {
	    display: inline-flex;
	    align-items: center;
	    margin: 0;
	    padding: 3px 5px;
	    width: 30%;
	    font-size: 13px;
	}
	.height-fixed-box li strong.namecolor-blue {
	    background-color: #0055d4;
	    border-top-left-radius: 8px;
	    border-top-right-radius: 8px;
	    padding: 9px 25px 6px;
	    font-size: 15px;
	    margin-bottom: 0;
	}
	.height-fixed-box li strong {
	    display: block;
	    background: #666;
	    color: #fff;
	    font-weight: 500;
	}
	.height-fixed-box .name:hover{
		text-decoration: underline; /* 悬停时添加下划线 */
	}
	
	/* 分类虚拟下拉样式 */
	.category-popper {
		max-width: 100vw;
		padding: 0 !important;
	}
	.category-dropdown-content {
		padding: 15px;
		background: #fff;
	}
	.scroller-container {
		border: 1px solid #eee;
		border-radius: 8px;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		height: 400px;
	}
	.v-table-header {
		display: flex;
		background-color: #f0f7ff;
		height: 40px;
		align-items: center;
		padding: 0 15px;
		font-weight: bold;
		color: #0055d4;
		font-size: 13px;
		border-bottom: 1px solid #d0e3f7;
	}
	.category-v-scroller {
		flex: 1;
	}
	.v-category-row {
		display: flex;
		align-items: center;
		padding: 0 15px;
		height: 65px;
		border-bottom: 1px solid #f5f5f5;
		box-sizing: border-box;
	}
	.v-category-row:hover {
		background-color: #fafafa;
	}
	.v-col-l1 { width: 120px; flex-shrink: 0; color: #0055d4; font-weight: bold; font-size: 13px; }
	.v-col-l2 { width: 220px; flex-shrink: 0; padding: 0 10px; display: flex; flex-direction: column; justify-content: center; }
	.v-col-l3 { flex: 1; min-width: 0; padding-left: 10px; display: flex; flex-direction: column; justify-content: center; }
	
	.v-category-row .ko { font-size: 13px; color: #333; margin-bottom: 2px; }
	.v-category-row .cn { font-size: 11px; color: #e67e22; font-weight: 500; }
	.v-category-row .code { color: #999; font-family: monospace; font-size: 11px; }

	::v-deep .hl-text-category {
		background-color: #fffb8f;
		color: #f5222d;
		font-weight: bold;
		padding: 0 2px;
		border-radius: 2px;
	}
	
	
	.color-blue {
	    color: #0055d4 !important;
	}
	.color-red {
	    color: #cc3333 !important;
	}
	.flex{
		display: flex;
	}
	::v-deep .el-table th.el-table__cell {
		text-align: center;
		color:#333;
	}
	.scope-a{
		color: #333;font-weight: 500;text-decoration: none;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.widget-location h3 {
		    font-size: 30px;
		    font-weight: bold;
		    margin: 0;
		    word-break: keep-all;
		}
		.unit-input{
			width:80%;
		}
		/* 列表 */
		.info-wrap{
			border-top: 2px solid var(--border-color);
			margin:10px 20px;
		}
		.item-info-wrap{
			padding:10px 0;
		}
		.item-info-wrap .item-center {
		    font-weight: bold;
		    font-size: 13px;
		    color: #666;
		}
		.item-info-wrap .item-code {
		    color: var(--main-color);
		    font-size: 13px;
		}
		.item-info-wrap .item-goodsname {
		    color: #333;
		    font-size: 13px;
		    line-height: 18px;
		    letter-spacing: -0.01em;
		    font-weight: bold;
		    margin-top: 5px;
		}
		.item-info-wrap .item-goodsname a {
		    color: #333;
			text-decoration: none;
		}
		.item-option-wrap {
			color:#333;
		    padding: 7px 10px 6px;
		    background: #f4f4f4;
		    font-size: 12px;
		    line-height: 19px;
		    letter-spacing: -0.01em;
		}
		.item-quantity-wrap {
			color:#333;
		    display: flex;
		    margin: 10px 0 10px;
		}
		.item-quantity-wrap .item-quantity {
		    flex: 1;
		    align-self: center;
		    background-color: #eff3f9;
		    padding: 7px 10px 6px;
		    display: flex;
		    gap: 5px;
		    justify-content: space-between;
		    flex-wrap: wrap;
		    font-size: 12px;
		}

	
	}
	.agency-info-row {
	    display: flex;
	    flex-wrap: wrap;
	    gap: 8px;
	    align-items: center;
	    padding: 4px 0;
	}
	.info-badge {
	    display: inline-flex;
	    align-items: center;
	    border: 1px solid #dcdfe6;
	    border-radius: 6px;
	    overflow: hidden;
	    font-size: 12px;
	    background: #fff;
	    line-height: 1.4;
	    box-shadow: 0 1px 2px rgba(0,0,0,0.02);
	}
	.badge-label {
	    background: #f5f7fa;
	    color: #606266;
	    padding: 5px 10px;
	    border-right: 1px solid #dcdfe6;
	    font-weight: bold;
	    white-space: nowrap;
	}
	.badge-value {
	    padding: 5px 12px;
	    color: #303133;
	    white-space: nowrap;
	}
	.search-card {
		background: #f8fafc;
		border: 1px solid #e2e8f0;
		border-radius: 12px;
		padding: 16px 20px;
		margin-bottom: 24px;
		box-shadow: 0 1px 3px rgba(0,0,0,0.02);
	}
	.search-form-inline {
		display: flex;
		flex-wrap: wrap;
		gap: 16px;
		align-items: center;
	}
	.form-item-group {
		display: inline-flex;
		align-items: center;
		gap: 8px;
	}
	.form-item-label {
		font-size: 13px;
		font-weight: 600;
		color: #475569;
		white-space: nowrap;
		min-width: 60px;
		text-align: right;
	}
	.form-item-input {
		width: 180px !important;
	}
	.form-action-group {
		display: inline-flex;
		align-items: center;
		gap: 10px;
		margin-left: auto;
	}
	@media (max-width: 768px) {
		.form-action-group {
			margin-left: 0;
			width: 100%;
			justify-content: flex-end;
		}
		.form-item-input {
			width: 100% !important;
		}
		.form-item-group {
			width: 100%;
		}
	}
</style>